<div class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>ADD Admin</h3>
    </div>
    <mat-divider></mat-divider>
    <form class="admin-forms mt-3" [formGroup]="AddLogin" autocomplete="off">
      <div class="row mtb input-fileds-container">
        <div class="col-sm-8">
          <!-- Row 1: EID and Name -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Emp ID</mat-label>
                <input matInput formControlName="employee_id" required />
                <mat-error>Please enter Emp ID</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" (keypress)="validateAlphabetsAndSpaces($event)" required />
                <mat-error *ngIf="AddLogin.get('name')?.hasError('required')">Please enter name</mat-error>
                <mat-error *ngIf="AddLogin.get('name')?.hasError('pattern')">Only alphabets and spaces allowed</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 1.5: Username and Password -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Username</mat-label>
                <input matInput formControlName="username" (keypress)="validateAlphaNumeric($event)" required autocomplete="none" />
                <mat-error *ngIf="AddLogin.get('username')?.hasError('required')">Please enter username</mat-error>
                <mat-error *ngIf="AddLogin.get('username')?.hasError('pattern')">Only alphanumeric characters allowed</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Password</mat-label>
                <input type="password" matInput formControlName="password" required autocomplete="new-password" />
                <mat-error>Please enter password</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 2: Email and Mobile -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" type="email" required />
                <mat-error>Please enter valid email</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Mobile</mat-label>
                <input matInput formControlName="mobile" maxlength="10" minlength="10" (keypress)="validateNumber($event)" required />
                <mat-error>Please enter mobile</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 3: DOB and Gender -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>DOB</mat-label>
                <input type="date" matInput formControlName="dob" required />
                <mat-error>Please enter DOB</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Gender</mat-label>
                <mat-select formControlName="gender" required>
                  <mat-option>Select Gender</mat-option>
                  <mat-option value="male">Male</mat-option>
                  <mat-option value="female">Female</mat-option>
                  <mat-option value="others">Others</mat-option>
                </mat-select>
                <mat-error>Please select gender</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Row 4: Role and SMS Toggle -->
          <div class="row mtb">
            <div class="col-sm-6">
              <mat-form-field class="example-full-width">
                <mat-label>Role</mat-label>
                <input matInput formControlName="role" required />
                <mat-error>Please enter role</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6 d-flex align-items-center">
              <mat-slide-toggle formControlName="is_sms_enabled" labelPosition="before">
                Enable SMS for Quote Notifications
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="row">
            <div class="col-sm-10 right-side">
              <img *ngIf="image_link" [src]="image_link" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%;" />
              <img *ngIf="!image_link" src="../../../assets/img/profile-upload.svg" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%;" />
              <div class="image-upload-area">
                <input #uploadImage type="file" (change)="onChange($event)" hidden />
              </div>
              <span class="head" style="cursor: pointer; color: blue; text-decoration: underline;" (click)="uploadImage.click()">
                {{ image_link ? 'Change Profile Picture' : 'Add Profile Picture' }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Permissions Area -->
      <div class="permissions-container mt-3">
        <h6>Module Permissions</h6>
        <div class="modules-grid">
          <div *ngFor="let module of adminModules" class="module-item">
            <mat-checkbox [checked]="selectedModules.includes(module.id)" (change)="toggleModule(module.id)">
              {{ module.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-sm-11">
          <div class="fixed-btn" style="text-align: right;">
            <button type="button" class="button buttonBlue" (click)="addAdmin()" [disabled]="isLoading">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>